import { FC, PropsWithChildren } from "react";

export type SearchBtnParam<T> = {
  label: string;
  query: T;
};

interface Props {
  header: JSX.Element;
}

const CategoryContainer: FC<PropsWithChildren<Props>> = ({
  children,
  header,
}): JSX.Element => {
  return (
    <main className="max-w-[1024px] w-full mx-auto laptop:py-48 laptop:space-y-48 small:pb-40 space-y-32 laptop:px-16">
      {header}

      <div className="space-y-48">{children}</div>
    </main>
  );
};

export default CategoryContainer;
